const fa = require('@fortawesome/fontawesome');
fa.library.add([
    // require('@fortawesome/fontawesome-free-solid'),
    require('@fortawesome/fontawesome-free-solid/faBars'),
    require('@fortawesome/fontawesome-free-solid/faCalendarAlt'),
    require('@fortawesome/fontawesome-free-solid/faChevronDown'),
    require('@fortawesome/fontawesome-free-solid/faChevronLeft'),
    require('@fortawesome/fontawesome-free-solid/faChevronRight'),
    require('@fortawesome/fontawesome-free-solid/faChevronUp'),
    require('@fortawesome/fontawesome-free-solid/faCircleNotch'),
    require('@fortawesome/fontawesome-free-solid/faCircleNotch'),
    require('@fortawesome/fontawesome-free-solid/faCopy'),
    require('@fortawesome/fontawesome-free-solid/faEllipsisH'),
    require('@fortawesome/fontawesome-free-solid/faEnvelope'),
    require('@fortawesome/fontawesome-free-solid/faFax'),
    require('@fortawesome/fontawesome-free-solid/faLocationArrow'),
    require('@fortawesome/fontawesome-free-solid/faMap'),
    require('@fortawesome/fontawesome-free-solid/faMapMarker'),
    require('@fortawesome/fontawesome-free-solid/faMapMarkerAlt'),
    require('@fortawesome/fontawesome-free-solid/faMobile'),
    require('@fortawesome/fontawesome-free-solid/faMobileAlt'),
    require('@fortawesome/fontawesome-free-solid/faPhone'),
    require('@fortawesome/fontawesome-free-solid/faQuestion'),
    require('@fortawesome/fontawesome-free-solid/faSearch'),
    require('@fortawesome/fontawesome-free-solid/faTimes'),
    require('@fortawesome/fontawesome-free-solid/faTruck'),
    require('@fortawesome/fontawesome-free-solid/faUser'),
]);


module.exports = {fa:fa};
